import React, { useEffect, useRef } from 'react';
import useVisualViewport from '../hooks/useVisualViewport';

export default function MaximizedPopup({ children, onBackdropClick, zIndex = 9999 }) {
  const { height: vpHeight, offsetTop } = useVisualViewport();
  const containerRef = useRef(null);

  useEffect(() => {
    const el = document.activeElement;
    const container = containerRef.current;
    if (!el || !container || !container.contains(el)) return;
    setTimeout(() => {
      const elRect = el.getBoundingClientRect();
      const contRect = container.getBoundingClientRect();
      const pad = 20;
      if (elRect.bottom > contRect.bottom - pad) {
        container.scrollTop += (elRect.bottom - contRect.bottom) + pad;
      }
    }, 200);
  }, [vpHeight, offsetTop]);

  return (
    <>
      <div onClick={onBackdropClick} style={{ position: 'fixed', inset: 0, background: '#000b', zIndex: zIndex - 1 }} />
      <div
        ref={containerRef}
        data-maxpopup="true"
        style={{
          position: 'fixed',
          top: `calc(${offsetTop}px + env(safe-area-inset-top, 0px) + 8px)`,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 'calc(100% - 24px)',
          maxWidth: 430,
          maxHeight: `calc(${vpHeight}px - env(safe-area-inset-top, 0px) - 64px)`,
          background: 'linear-gradient(145deg, rgba(45,26,74,0.97) 0%, rgba(15,45,74,0.97) 55%, rgba(16,14,26,0.97) 100%)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          borderRadius: 20,
          zIndex,
          overflowY: 'auto',
          overflowX: 'hidden',
          overscrollBehavior: 'contain',
        }}
      >
        {children}
      </div>
    </>
  );
}
